//Action creator
export const logIn = (user) => {
//Return an action
return {
type:"LOG_IN",
payload:user
};

};
